/* src/app/pages/dashboard/dialog/dialog.component.scss */
/*# sourceMappingURL=dialog.component.css.map */
